<template>
  <section>
    <!-- <el-dialog :visible.sync="dialogVisible_approve">
        <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
      </el-dialog> -->
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form
      class="form_cls"
      v-if="buttonList != null && buttonList.length > 0 && currentuserrole == '一线销售'"
      :model="filters"
      @submit.native.prevent
      inline
    >
      <el-form-item label="">
        <el-select
          multiple
          collapse-tags
          style="width: 330px"
          v-model="filters.zcnCodes"
          filterable
          :filter-method="options_expend_fn"
          :reserve-keyword="true"
          placeholder="请选择医院"
        >
          <el-option v-for="item in options_expend" :key="item.bwAcctNumber" :label="item.name" :value="item.bwAcctNumber">
            <span
              slot="default"
              :title="item.label"
              style="width: 260px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block"
            >
              {{ item.name }}
            </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="filters.day"
          style="width: 250px !important"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          prefix-icon="1"
          placeholder="请选择日期"
        ></el-date-picker>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item
        v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
        class="input_width_100"
        v-for="item in buttonList"
        v-bind:key="item.id"
      >
        <!-- 这里触发点击事件 -->
        <el-button
          style="margin-bottom: 8px"
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div v-if="currentuserrole == '一线销售'" class="table_top_div">
      <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
        <el-table
          class="expends_cls"
          :data="tabel_list"
          :border="true"
          cell-class-name="cell_class_name"
          max-height="100%"
          header-cell-class-name="header_cell_name"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column prop="productCode" label="产品" width="">
            <template slot-scope="scope">
              <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                {{ scope.row.productCode }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="当月MTD">
            <el-table-column prop="mtd" label="数量" width="65">
              <template slot-scope="scope">
                <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                  {{ currency(scope.row.mtd) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="monthAchDaily" label="达成" width="65">
              <template slot-scope="scope">
                <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                  {{ scope.row.monthAchDaily.toFixed(0) }}%
                </span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="todaylabel">
            <el-table-column prop="daily" label="数量" width="65">
              <template slot-scope="scope">
                <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                  {{ currency(scope.row.daily) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="achDaily" label="达成" width="65">
              <template slot-scope="scope">
                <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">{{ scope.row.achDaily.toFixed(0) }}%</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="currentuserrole != '一线销售'" class="table_top_div" style="padding-top: 0">
      <el-tabs stretch v-model="activeName">
        <el-tab-pane label="按产品" name="1">
          <span slot="label" style="font-size: 14px">按产品</span>
          <el-form
            style="padding-left: 0 !important"
            class="form_cls"
            v-if="buttonList != null && buttonList.length > 0"
            :model="filters"
            @submit.native.prevent
            inline
          >
            <el-form-item v-if="currentuserrole == '小区经理'" label="">
              <el-select
                multiple
                collapse-tags
                style="width: 320px"
                v-model="filters.salesPosition"
                filterable
                :filter-method="system_getsaleslistundersubregionmanager_fn"
                :reserve-keyword="true"
                placeholder="请选择销售代表"
              >
                <el-option v-for="item in options_saleslistundersubregionmanager" :key="item.value" :label="item.name" :value="item.value">
                  <span
                    slot="default"
                    :title="item.label"
                    style="width: 180px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block"
                  >
                    {{ item.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="currentuserrole == '大区经理'" label="">
              <el-select
                multiple
                collapse-tags
                style="width: 320px"
                v-model="filters.subRegionIds"
                filterable
                :filter-method="system_getsubregionlistunderregionmanager_fn"
                :reserve-keyword="true"
                placeholder="请选择区域"
              >
                <el-option v-for="item in options_subregionlistunderregionmanager" :key="item.value" :label="item.name" :value="item.value">
                  <span
                    slot="default"
                    :title="item.label"
                    style="width: 180px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block"
                  >
                    {{ item.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="currentuserrole == '产品线负责人' || currentuserrole == 'Leaders'" label="">
              <el-select
                multiple
                collapse-tags
                style="width: 320px"
                v-model="filters.regionIds"
                filterable
                :filter-method="system_getregionlistunderproductlinemanager_fn"
                :reserve-keyword="true"
                placeholder="请选择区域"
              >
                <el-option v-for="item in options_regionlistunderproductlinemanager" :key="item.value" :label="item.name" :value="item.value">
                  <span
                    slot="default"
                    :title="item.label"
                    style="width: 180px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block"
                  >
                    {{ item.name }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="
                currentuserrole == '大区经理' || currentuserrole == '小区经理' || currentuserrole == '产品线负责人' || currentuserrole == 'Leaders'
              "
              label=""
            >
              <el-date-picker
                v-model="filters.day"
                style="width: 240px !important"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                prefix-icon="1"
                placeholder="请选择日期"
              ></el-date-picker>
            </el-form-item>
            <!-- 这个就是当前页面内，所有的btn列表 -->
            <el-form-item
              v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
              class="input_width_100"
              v-for="item in buttonList"
              v-bind:key="item.id"
            >
              <!-- 这里触发点击事件 -->
              <el-button
                style="margin-bottom: 8px"
                :type="
                  item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1)
                    ? 'danger'
                    : 'primary'
                "
                @click="callFunc(item)"
              >
                {{ item.name }}
              </el-button>
            </el-form-item>
          </el-form>
          <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
            <el-table
              class="expends_cls"
              :data="tabel_list"
              :border="true"
              cell-class-name="cell_class_name"
              max-height="100%"
              header-cell-class-name="header_cell_name"
              highlight-current-row
              @current-change="selectCurrentRow"
              v-loading="listLoading"
              @selection-change="selsChange"
              style="width: 100%"
            >
              <el-table-column prop="productCode" label="产品" width="">
                <template slot-scope="scope">
                  <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                    {{ scope.row.productCode }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="当月MTD">
                <el-table-column prop="mtd" label="数量" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ currency(scope.row.mtd) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="monthAchDaily" label="达成" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ scope.row.monthAchDaily.toFixed(0) }}%
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column :label="todaylabel">
                <el-table-column prop="daily" label="数量" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ currency(scope.row.daily) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="achDaily" label="达成" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ scope.row.achDaily.toFixed(0) }}%
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="currentuserrole != '一线销售'" label="按区域" name="2">
          <span slot="label" style="font-size: 14px">按区域</span>
          <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
            <el-table
              class="expends_cls"
              :data="tabel_list2"
              :border="true"
              cell-class-name="cell_class_name"
              max-height="100%"
              header-cell-class-name="header_cell_name"
              highlight-current-row
              @current-change="selectCurrentRow"
              v-loading="listLoading"
              @selection-change="selsChange"
              style="width: 100%"
            >
              <el-table-column v-if="currentuserrole == '小区经理'" prop="salesName" label="销售代表" width="">
                <template slot-scope="scope">
                  <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                    {{ scope.row.salesName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column v-else prop="subRegion" label="区域" width="">
                <template slot-scope="scope">
                  <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                    {{ scope.row.subRegion }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="MTD">
                <el-table-column prop="mtd" label="数量" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ currency(scope.row.mtd) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="monthAchDaily" label="达成" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      <span :style="scope.row.isBold ? 'font-weight: bold' : ''">{{ scope.row.monthAchDaily.toFixed(0) }}%</span>
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column :label="todaylabel_qy">
                <el-table-column prop="daily" label="数量" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ currency(scope.row.daily) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="achDaily" label="达成" width="65">
                  <template slot-scope="scope">
                    <span :style="scope.row.isBold ? 'font-weight: bold;font-size:12px' : 'font-size:12px'">
                      {{ scope.row.achDaily.toFixed(0) }}%
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  system_getcurrentuserrole,
  expend_exportdata,
  expend_submitestimate,
  expend_getmanagedhospitals,
  expend_getdailyreportbyproduct,
  system_getsaleslistundersubregionmanager,
  system_getsubregionlistunderregionmanager,
  system_getregionlistunderproductlinemanager,
  expend_getdailyreportbyregion,
  expend_getregionalmanagerdailyreport,
  expend_getregionaldailyreport,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
import ExpendListMobileAll from './mobile/ExpendListMobileAll'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve, ExpendListMobileAll },
  data() {
    return {
      todaylabel: '',
      todaylabel_qy: '',
      todays: '',
      reg_list: ['汇总'],
      jjsv_product_list: ['景深延长(散+非散)', '三焦点(散+非散)', '双焦(散+非散)', '单焦散光', '单焦非散'],
      currentuserrole: '一线销售',
      activeName: '1',
      tabel_list2: [],
      options_expend: [],
      upload_from: {},
      dialogVisible_approve: false,
      dialogVisible_upload: false,
      SP_IF: '',
      isMobile: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 200,
        day: '',
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      total2: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
      options_saleslistundersubregionmanager: [],
      options_subregionlistunderregionmanager: [],
      options_regionlistunderproductlinemanager: [],
    }
  },
  methods: {
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    async system_getregionlistunderproductlinemanager_fn(e) {
      const { data } = await system_getregionlistunderproductlinemanager({ keyword: e })
      this.options_regionlistunderproductlinemanager = data.data
    },
    async system_getsubregionlistunderregionmanager_fn(e) {
      const { data } = await system_getsubregionlistunderregionmanager({ keyword: e })
      this.options_subregionlistunderregionmanager = data.data
    },
    async system_getsaleslistundersubregionmanager_fn(e) {
      const { data } = await system_getsaleslistundersubregionmanager({ keyword: e })
      this.options_saleslistundersubregionmanager = data.data
    },
    async expend_getmanagedhospitals_fn(e) {
      const { data } = await expend_getmanagedhospitals({ keyword: e })
      this.options_expend = data.data
    },
    options_expend_fn(e) {
      this.expend_getmanagedhospitals_fn(e)
    },
    async save(res) {
      const { data } = await expend_submitestimate(res)
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    async uploads() {
      let para = this.upload_from
      if (!para.endTime || !para.startTime) {
        this.$message.error('请选择开始时间和结束时间')
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await expend_exportdata(para)
      uploadfiles(data, headers, this.loading)
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 17 === 0) {
          return {
            rowspan: 17,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
      //   this.getModules2()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          dip: item.dip,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = JSON.parse(JSON.stringify(this.filters))
      para.pageNumber = this.pageNumber
      if (para.zcnCodes) {
        para.zcnCodes = para.zcnCodes.toString()
      }
      if (para.salesPosition) {
        para.salesPosition = para.salesPosition.toString()
      }
      if (para.subRegionIds) {
        para.subRegionIds = para.subRegionIds.toString()
      }
      if (para.regionIds) {
        para.regionIds = para.regionIds.toString()
      }
      this.todaylabel = para.day
      this.listLoading = true
      expend_getdailyreportbyproduct(para).then((res) => {
        console.log(res)
        this.total = res.data.data.dataCount
        this.tabel_list = res.data.data
        this.listLoading = false
      })
    },
    //获取用户列表
    async getModules2() {
      //         expend_getdailyreportbyregion,
      //   expend_getregionalmanagerdailyreport,
      //   expend_getregionaldailyreport,
      if (this.currentuserrole == '一线销售') {
        return
      }
      this.listLoading = true
      var data
      if (this.currentuserrole == '小区经理') {
        console.log('小区经理')
        data = await expend_getregionaldailyreport()
      }
      if (this.currentuserrole == '大区经理') {
        console.log('大区经理')
        data = await expend_getregionalmanagerdailyreport()
      }
      if (this.currentuserrole == '产品线负责人' || this.currentuserrole == 'Leaders') {
        console.log('产品线负责人')
        data = await expend_getdailyreportbyregion()
      }
      console.log(data)
      this.total2 = data.data.dataCount
      this.tabel_list2 = data.data.data
      this.listLoading = false
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async system_getcurrentuserrole_fn() {
      const { data } = await system_getcurrentuserrole()
      this.currentuserrole = data.data

      this.getModules()
      this.getModules2()
      if (this.currentuserrole == '一线销售') {
        this.expend_getmanagedhospitals_fn('')
      }
      if (this.currentuserrole == '小区经理') {
        this.system_getsaleslistundersubregionmanager_fn('')
      }
      if (this.currentuserrole == '大区经理') {
        this.system_getsubregionlistunderregionmanager_fn('')
      }
      if (this.currentuserrole == '产品线负责人' || this.currentuserrole == 'Leaders') {
        this.system_getregionlistunderproductlinemanager_fn('')
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    this.system_getcurrentuserrole_fn()
    var time = new Date()
    var year = time.getFullYear()
    var month = time.getMonth() + 1
    var day = time.getDate()
    // this.todays =
    var todays = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    this.filters.day = todays
    this.todaylabel = todays
    this.todaylabel_qy = todays
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style>
.expends_cls .cell {
  padding: 0 5px !important;
}
.expends_cls td.el-table__cell {
  padding: 1px 0 !important;
}
</style>
